function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Service from '@ember/service';
import IntersectionObserverAdmin from 'intersection-observer-admin';
export default class ObserverManagerService extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_admin", new IntersectionObserverAdmin());
  }
  observe(element, options) {
    this._admin.observe(element, options);
  }
  unobserve(element, options) {
    this._admin.unobserve(element, options);
  }
  addEnterCallback(element, callback) {
    this._admin.addEnterCallback(element, callback);
  }
  addExitCallback(element, callback) {
    this._admin.addExitCallback(element, callback);
  }
  willDestroy() {
    this._admin.destroy();
  }
}